type CreditTypeSource = { creditTypeIds?: string[] | null };

export function creditTypeIdsFromSource(source?: CreditTypeSource | null): string[] {
  return source?.creditTypeIds ?? [];
}
